"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditCardField = exports.CreditCardData = void 0;
const query_1 = require("./query");
class CreditCardData {
    constructor() {
        this.Type = 'Unselected';
        this.CreditCardName = '';
        this.CreditCardNumber = '';
        this.ExpiryMonth = 1;
        this.ExpiryYear = 2000;
        this.CCV = '';
    }
    toString() {
        let lst = [];
        if (this.Type && this.Type != 'Unselected') {
            if (this.CreditCardName) {
                lst.push(`${this.CreditCardName}, ${this.Type}`);
            }
        }
        else {
            if (this.CreditCardName) {
                lst.push(`${this.CreditCardName}`);
            }
        }
        if (`${this.CreditCardNumber || ''}`.split('✕').join('').trim().length > 4) {
            lst.push(`Card ending with ${this.CreditCardNumber.substring(this.CreditCardNumber.length - 4)}`);
        }
        if (lst.length) {
            lst.push(`Expiring ${this.ExpiryMonth} / ${this.ExpiryYear}`);
        }
        else {
            lst.push(`Not specified`);
        }
        return lst.join('\n');
    }
}
exports.CreditCardData = CreditCardData;
class CreditCardField {
    constructor(container) {
        this.container = container;
        query_1.Z.forEachFrom(container, '[data-subfield="card-type"]', el => {
            this.cardTypeSelect = el;
            el.addEventListener('change', ev => this.updateValueFromControls());
        });
        query_1.Z.forEachFrom(container, '[data-subfield="card-holder"]', el => {
            this.cardHolderName = el;
            el.addEventListener('input', ev => this.updateValueFromControls());
        });
        query_1.Z.forEachFrom(container, '[data-subfield="card-numbers-1"]', el => {
            this.cardNumbers1 = el;
            query_1.Z.restrictInputCharacters(el, '0123456789');
            el.addEventListener('input', ev => {
                this.updateValueFromControls();
                if (el.value.length == 4 && this.cardNumbers2)
                    this.cardNumbers2.focus();
            });
        });
        query_1.Z.forEachFrom(container, '[data-subfield="card-numbers-2"]', el => {
            this.cardNumbers2 = el;
            query_1.Z.restrictInputCharacters(el, '0123456789');
            el.addEventListener('input', ev => {
                this.updateValueFromControls();
                if (el.value.length == 4 && this.cardNumbers3)
                    this.cardNumbers3.focus();
            });
        });
        query_1.Z.forEachFrom(container, '[data-subfield="card-numbers-3"]', el => {
            this.cardNumbers3 = el;
            query_1.Z.restrictInputCharacters(el, '0123456789');
            el.addEventListener('input', ev => {
                this.updateValueFromControls();
                if (el.value.length == 4 && this.cardNumbers4)
                    this.cardNumbers4.focus();
            });
        });
        query_1.Z.forEachFrom(container, '[data-subfield="card-numbers-4"]', el => {
            this.cardNumbers4 = el;
            query_1.Z.restrictInputCharacters(el, '0123456789');
            el.addEventListener('input', ev => {
                this.updateValueFromControls();
            });
        });
        query_1.Z.forEachFrom(container, '[data-subfield="card-expiry-month"]', el => {
            this.cardExpiryMonth = el;
            el.addEventListener('change', ev => this.updateValueFromControls());
        });
        query_1.Z.forEachFrom(container, '[data-subfield="card-expiry-year"]', el => {
            this.cardExpiryYear = el;
            el.addEventListener('change', ev => this.updateValueFromControls());
        });
        query_1.Z.forEachFrom(container, '[data-subfield="card-ccv"]', el => {
            this.cardCCV = el;
            query_1.Z.restrictInputCharacters(el, '0123456789');
            el.addEventListener('input', ev => this.updateValueFromControls());
        });
        query_1.Z.forEachFrom(container, '[data-subfield="value"]', el => {
            this.input = el;
        });
        this.updateValueFromControls();
    }
    get value() {
        var data = new CreditCardData();
        if (this.cardTypeSelect)
            data.Type = this.cardTypeSelect.value;
        if (this.cardHolderName)
            data.CreditCardName = this.cardHolderName.value;
        if (this.cardExpiryMonth)
            data.ExpiryMonth = parseInt(this.cardExpiryMonth.value);
        if (this.cardExpiryYear)
            data.ExpiryYear = parseInt(this.cardExpiryYear.value);
        if (this.cardCCV)
            data.CCV = (this.cardCCV.value) || '';
        let number = '';
        if (this.cardNumbers1)
            number += this.cardNumbers1.value;
        if (this.cardNumbers2)
            number += this.cardNumbers2.value;
        if (this.cardNumbers3)
            number += this.cardNumbers3.value;
        if (this.cardNumbers4)
            number += this.cardNumbers4.value;
        data.CreditCardNumber = number;
        return data;
    }
    set value(data) {
        if (!data)
            data = new CreditCardData();
        if (this.cardTypeSelect)
            this.cardTypeSelect.value = data.Type;
        if (this.cardHolderName)
            this.cardHolderName.value = data.CreditCardName;
        if (this.cardExpiryYear)
            this.cardExpiryYear.value = data.ExpiryYear.toString();
        if (this.cardExpiryMonth)
            this.cardExpiryMonth.value = data.ExpiryMonth.toString();
        if (this.cardCCV)
            this.cardCCV.value = data.CCV.toString().padStart(3, '0');
        let number = (data.CreditCardNumber || '').padEnd('1234123412341234'.length);
        if (this.cardNumbers1 && !this.cardNumbers1.readOnly) {
            this.cardNumbers1.value = number.substr(0, 4); // TODOLATE23
        }
        if (this.cardNumbers2 && !this.cardNumbers2.readOnly) {
            this.cardNumbers2.value = number.substr(4, 4); // TODOLATE23
        }
        if (this.cardNumbers3 && !this.cardNumbers3.readOnly) {
            this.cardNumbers3.value = number.substr(8, 4); // TODOLATE23
        }
        if (this.cardNumbers4 && !this.cardNumbers4.readOnly) {
            this.cardNumbers4.value = number.substr(12, 4); // TODOLATE23
        }
    }
    updateValueFromControls() {
        if (this.input)
            this.input.value = JSON.stringify(this.value);
        query_1.Z.forEachFrom(this.container, '[data-subfield="print"]', l => {
            l.innerText = this.value.toString();
        });
    }
    static init() {
        query_1.Z.init('.credit-card-field', 'credit-card-field-editor', el => {
            return new CreditCardField(el);
        });
    }
}
exports.CreditCardField = CreditCardField;
//# sourceMappingURL=creditCardFieldEditor.js.map